import React from 'react'
import './productlist.css'
import Product from './Product'

const products = [
  {
    id: 1,
    img: "https://d33wubrfki0l68.cloudfront.net/60aca7d274fb3100070e7adf/screenshot_2021-05-25-07-32-10-0000.png",
    link: "https://souq-a.netlify.app/"
  },
  {
    id: 2,
    img: "https://d33wubrfki0l68.cloudfront.net/6086fb2a5c70820007860718/screenshot_2021-04-26-17-41-33-0000.png",
    link: "https://blog-app-2020.netlify.app/"
  },
  {
    id: 3,
    img: "https://d33wubrfki0l68.cloudfront.net/5fa1ff2c4083b8214f0803ba/screenshot.png",
    link: "https://to-do-app-ahmed.netlify.app/"
  }
]

function ProductList() {
  return (
    <div className='pl'>
      <div className="pl-texts">
        <h1 className="pl-title">Lorem ipsum dolor sit.</h1>
        <p className="pl-desc">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Necessitatibus laudantium excepturi similique illum doloribus atque incidunt, facilis quo amet laborum non ipsum vero, nostrum, minima dicta asperiores numquam neque porro ex. Hic, rem.

        </p>
      </div>
      <div className="pl-list">
        {products.map(item => (
          <Product key={item.id} img={item.img} link={item.link} />
        ))}

      </div>
    </div>
  )
}

export default ProductList
